import {ReloadButton,} from '@flexinet/ui-components';

import {Box,} from '@mantine/core';

import {useReconciliationReports} from '../hooks/useReconciliationReports.ts';

export const ReloadRecordsButton = () => {

    const {reload} = useReconciliationReports();
    return (
        <Box mx='s'>
            <ReloadButton onClick={() => reload()}/>
        </Box>
    );
};
